// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> landmark-at-glenmont-station
// Generated: 2026-10-22T20:06:49.471Z
// Counts: 1 design, 68 content, 58 slot group, 2 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio - 2 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio - 2 Bedroom Apartments for Rent in Silver Spring , MD</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Landmark at Glenmont Station, where comfort meets convenience in Silver Spring! Choose from spacious one or two-bedroom floor plans, and immerse yourself in vibrant local attractions like Brookside Gardens, the AFI Silver Theatre, and the National Capital Trolley Museum. Your new home is surrounded by endless possibilities!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Space, Your Home, Your Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=160/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Landmark at Glenmont Station in Silver Spring, MD, your ideal home awaits! Choose from <a href=\"https://www.landmarkatglenmontstation.com/floor-plans/\">one and two-bedroom floor plans</a> designed for comfort. Enjoy unparalleled amenities like a sleek fitness center, inviting swimming pool, and engaging resident activities—all complemented by a bilingual team ready to assist you.&nbsp;</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Landmark at Glenmont Station in Silver Spring, MD, choose from spacious one- and two-bedroom floor plans. Enjoy a vibrant lifestyle with amenities like a swimming pool, fitness center, and dog park, all while savoring the convenience of a bilingual management team and hassle-free online leasing. Your ideal home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Landmark at Glenmont Station in Silver Spring, MD, find your perfect home with our stylish one and two-bedroom floor plans. Experience modern living with versatile spaces tailored to your lifestyle. Have questions? Contact our leasing team today and let us help you take the next step toward your new apartment!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Landmark at Glenmont Station in Silver Spring, MD, your ideal living space awaits. Choose between stylish one and two-bedroom floor plans designed for comfort and modern living. Browse our available apartment homes today and picture yourself thriving in a vibrant community just moments from everything you love.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Landmark at Glenmont Station in Silver Spring, MD, picture a vibrant lifestyle where comfort meets community. Choose from spacious one- and two-bedroom floor plans, all while enjoying pet-friendly amenities, a modern fitness center, and relaxing poolside vibes. Elevate your living experience—schedule your visit today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Landmark at Glenmont Station, where comfort meets convenience in Silver Spring! Choose from spacious one or two-bedroom floor plans, and immerse yourself in vibrant local attractions like Brookside Gardens, the AFI Silver Theatre, and the National Capital Trolley Museum. Your new home is surrounded by endless possibilities!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in Silver Spring , MD</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We’re a pet‑friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. Monthly pet rent is $25.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your perfect fit in a great location in Wheaton-Glenmont with a studio, one, or two bedroom apartment at Landmark Glenmont Station. This pet-friendly community features amenities designed to simplify your life and a friendly vibe that will make you feel welcome from day one. Our spacious floor plans have been thoughtfully upgraded for style and comfort.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Landmark at Glenmont Station in vibrant Silver Spring, MD, where modern living meets comfort. Choose from stylish one or two-bedroom floor plans tailored to your lifestyle. Access your resident portal for effortless rent payments, maintenance requests, and exclusive community updates – your convenience is just a click away!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Landmark at Glenmont Station in Silver Spring, MD, our thoughtfully designed one and two-bedroom apartments harmonize comfort and style. Experience the vibrant community and stunning amenities that make everyday living exceptional. Curious about life here? Hear directly from our residents and schedule a tour to envision your new home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Landmark at Glenmont Station in Silver Spring, MD! Whether you envision a cozy one-bedroom retreat or a spacious two-bedroom haven, our diverse floor plans cater to your lifestyle. Stay tuned—our dedicated team will be in touch soon to help you find your perfect home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Landmark at Glenmont Station in Silver Spring, MD, where comfort meets style. Choose from our thoughtfully designed <a href=\"https://www.landmarkatglenmontstation.com/floor-plans/\">one and two-bedroom floor plans</a>. Experience your future home firsthand—take a virtual tour today and immerse yourself in the vibrant lifestyle that awaits you in our welcoming community!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-9c5e-709c-8380-c85aeba797d6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "In-home kitchen with dark wood cabinets, stainless steel appliances, granite countertops, and washer and dryer at Landmark at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-d99c-725f-9073-611640cabf9c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community game room with a pool table, air hockey, and bar seating at Landmark at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-d712-7715-8aff-5f02b1101637.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lounge area with black and yellow patterned furniture, dark gray wall with TV, and colorful rug at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-e5ce-715e-9f7c-837da44d9d75.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym interior with workout equipment and mats on a wooden floor. Dark blue walls, black ceiling, and open doorway at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-d99c-725f-9073-611640cabf9c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Game room with pool table, air hockey, orange accent wall, and bar seating at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-9c5e-709c-8380-c85aeba797d6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with dark wood cabinets, stainless steel appliances, and gray countertops at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-c362-748c-9e34-d5cde37f6640.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom interior with a bed, dresser, art, and doorway to another room. Neutral color palette at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-bf13-71f5-a8c6-cf6e37db6153.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with sofa, TV, coffee table, and balcony access. Beige and white tones at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166326/019d0267-e380-73af-b7fd-7cf9d75043dd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Downtown Silver Spring plaza with shops, a fountain, and crowds near Landmark at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166326/019d0267-e380-73af-b7fd-7cf9d75043dd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Downtown Silver Spring plaza with shops, fountain, and a large crowd of people."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166326/019d026a-a129-77da-af62-73905469c550.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Glenmont Metro Station Sign"
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166326/019d026a-9e53-7698-b45f-65dd26b81d48.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior of a subway station with two trains on parallel tracks."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fcad-71df-8457-94a14e9a2c75.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool with orange umbrellas and lounge chairs surrounded by trees at Landmark at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fcad-71df-8457-94a14e9a2c75.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Swimming pool with orange umbrellas and lounge chairs, surrounded by trees and a brick building at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-092b-7397-9d8f-7426e8e6dd44.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment on green grass, fenced off, with apartment building in the background at Glenmont Station in Silver Spring, MD."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166326/019d0267-dc22-726e-9aca-50860625409f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Picnic tables and grills in a grassy courtyard with apartment buildings in the background."
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "5%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.parking_reserved": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Parking - Reserved/Covered"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$40"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$1"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$5"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce6b-940e-724f-9903-978da65fa62a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Landmark at Glenmont Station in Silver Spring, MD"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce6b-9365-742a-97c9-2eee36ad5259.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Landmark at Glenmont Station in Silver Spring, MD"
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce6b-95a2-7048-acb9-8646ca4dbcd9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Landmark at Glenmont Station in Silver Spring, MD"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce6b-8eb4-760a-9a79-fbc4d29d35a0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Landmark at Glenmont Station in Silver Spring, MD"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d026a-d72a-7179-bf91-e6d4994d15ea.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with white sofa, armchair, glass coffee table, and TV."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-359b-7243-9b5f-0e2de5c0ba6c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Red Ribbon Bakeshop"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Bakery"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Beloved Filipino bakeshop for morning coffee alongside cakes, sweet rolls and savory-filled pastries."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-7345-733d-9aa4-765798dde2d6.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Westfield Wheaton"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.3 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Indoor mall packed with shopping and dining, plus a kids' play area and a train for the little ones."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-80a2-7333-ae63-af5c4bd161c3.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Brookside Gardens"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Gardens"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Sprawling 50-acre green space with conservatories, water features, seasonal flowers and fruit trees."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-22f7-719c-b11b-13901cec1bde.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Regina's Restaurant"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual eatery serving Italian and Mediterranean staples in a relaxed, welcoming setting."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6015-75ee-bac8-62026fd18c60.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "National Capital Trolley Museum"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Museum showcasing classic streetcars from around the world, with rides along a one-mile railway."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-821a-7508-9c9e-6f4ffcc52124.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Wheaton Regional Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Sprawling county park with wooded trails, playgrounds, a nature center, tennis courts and stables."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-22aa-70bd-96cd-02723c9f1b60.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Stained Glass Pub - Glenmont"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bars & Nightlife"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual neighborhood watering hole for TV sports, live music and a hearty pub-fare menu."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-589f-723e-bfd8-4512571ef101.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Fillmore Silver Spring"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Spacious downtown music venue where big-name artists and national acts play beneath ornate decor."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3845-73a0-94ca-58088bea2fb9.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Azucar Restaurant"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Lively neighborhood spot serving Mexican and Pan-Latin dishes in colorful, festive quarters."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-21ce-7410-a526-29ffaa60a282.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Limerick Pub"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bars & Lounges"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.9 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Traditional Irish pub pouring Guinness with bangers & mash and live folk music through the week."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-5575-7468-8fdc-b754a5e4ac0e.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "AFI Silver Theatre and Cultural Center"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Theater"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.9 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Historic cinema hosting film festivals plus new releases, classic movies and documentaries."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3296-7358-bbbe-6cd43dd36d53.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Jollibee"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Late-Night Eats"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Globally loved Philippines-based chain famed for its fried chicken, spaghetti and burgers."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 30,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": [
      "custom_4617b491-7e0f-4fc2-8375-46325b261c02",
      "custom_39090327-297b-4be4-a259-7aa2307e889b",
      "custom_feb20dd8-2805-4cbc-b2dd-8589b34c619c",
      "custom_14bdf339-f961-4f2b-bc68-4bed1d5e86d5",
      "custom_fd544eff-8d42-46a3-b4c6-a0db3e62a93d",
      "custom_a331e97b-bc59-4bdf-a427-077666aa5e36",
      "custom_5e6e6215-f5ba-453b-8153-c6848d23bac9",
      "custom_bda45ace-03eb-4e44-850d-28c92238a3a5",
      "custom_832293be-40c6-49e6-b192-c3408805386c",
      "custom_405d0c5d-90e8-47c9-8eed-d83622d41e69",
      "custom_caef9959-ec53-438d-88a3-7a6be7af2da5",
      "custom_b17dd44a-7ac6-4b25-b794-8130d646e68e",
      "custom_4a223cc0-da1d-4c12-87f1-e076f1cc36c3",
      "custom_0fbac786-9505-4877-8237-d9901cccfd1c",
      "custom_15ba926f-dbbc-4891-aa0c-059d7a2ab4a5",
      "custom_e0940b38-c3c2-4807-9a57-a32ec6b3cfc2",
      "custom_aa3a5a2b-dcf1-4302-a371-070cc81d9ffe",
      "custom_52b83b7c-1d54-4c5b-88d7-6ec5a7819032",
      "custom_d8c74050-9fa2-4abe-84b4-a1013955c7ec",
      "custom_c231fa78-1e02-4de7-9eb9-f6b0885c424a",
      "custom_4841a264-b2a8-434b-b425-624cc14a3129",
      "custom_15340891-3a72-48af-b805-a4eb6034e47d",
      "custom_0860cc85-27f5-420d-900f-88a6c063903c"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": [
      "custom_bda45ace-03eb-4e44-850d-28c92238a3a5",
      "custom_832293be-40c6-49e6-b192-c3408805386c",
      "custom_48eb00f8-cc04-4971-b250-4177e1a7af3b",
      "custom_0bae0ae6-a440-4569-8d6a-dd681a394f24",
      "custom_5e6e6215-f5ba-453b-8153-c6848d23bac9",
      "custom_f7ee1b1e-15db-40f4-a40a-98c4346fa16d"
    ],
    "orderedIds": [
      "custom_d8c74050-9fa2-4abe-84b4-a1013955c7ec",
      "custom_4617b491-7e0f-4fc2-8375-46325b261c02",
      "custom_15340891-3a72-48af-b805-a4eb6034e47d",
      "custom_52b83b7c-1d54-4c5b-88d7-6ec5a7819032",
      "custom_4841a264-b2a8-434b-b425-624cc14a3129",
      "custom_feb20dd8-2805-4cbc-b2dd-8589b34c619c",
      "custom_fd544eff-8d42-46a3-b4c6-a0db3e62a93d",
      "custom_a331e97b-bc59-4bdf-a427-077666aa5e36",
      "custom_0860cc85-27f5-420d-900f-88a6c063903c",
      "custom_e0940b38-c3c2-4807-9a57-a32ec6b3cfc2",
      "custom_c231fa78-1e02-4de7-9eb9-f6b0885c424a",
      "custom_15ba926f-dbbc-4891-aa0c-059d7a2ab4a5",
      "custom_39090327-297b-4be4-a259-7aa2307e889b",
      "custom_aa3a5a2b-dcf1-4302-a371-070cc81d9ffe",
      "custom_5e6e6215-f5ba-453b-8153-c6848d23bac9",
      "custom_14bdf339-f961-4f2b-bc68-4bed1d5e86d5",
      "custom_bda45ace-03eb-4e44-850d-28c92238a3a5",
      "custom_832293be-40c6-49e6-b192-c3408805386c",
      "custom_405d0c5d-90e8-47c9-8eed-d83622d41e69",
      "custom_caef9959-ec53-438d-88a3-7a6be7af2da5",
      "custom_b17dd44a-7ac6-4b25-b794-8130d646e68e",
      "custom_4a223cc0-da1d-4c12-87f1-e076f1cc36c3",
      "custom_0fbac786-9505-4877-8237-d9901cccfd1c",
      "custom_c1608d8e-7cf7-4283-8314-a5c957d062a9",
      "custom_c98f4009-82b4-458e-aeb9-dfef4aa79255",
      "custom_10c21f9c-bb23-4a1c-89b2-0fea0e012406",
      "custom_3654cb81-2198-493d-9611-b491b1bb0ce1",
      "custom_7b719385-27d5-4fbe-bef2-aff14983fdbb",
      "custom_c58b27e3-f7aa-4d48-a56d-62d75d667378",
      "custom_89db6b6c-7ab4-4aa9-b1ab-fcde2e76ab48",
      "custom_2840f5de-0a49-4672-886e-d96ebb764c98",
      "custom_474073ea-b399-42c9-a594-f96d39d8e852",
      "custom_854bccd8-cfc4-40d0-92c6-cf821f01ed6d",
      "custom_0d353413-4786-42bd-ae57-eb8f7ed3751b",
      "custom_f460ad9b-1fc6-4782-86ef-58158655be95",
      "custom_e312ebff-7a41-45ec-ad70-6595ba142f34",
      "custom_bdf80f5a-802f-4d9c-927e-f253cf5c2248",
      "custom_f7ee1b1e-15db-40f4-a40a-98c4346fa16d",
      "custom_fe1cc745-dc0d-4f5b-94aa-74fef82c98af",
      "custom_74189321-709b-4760-85e7-4df4314daedd",
      "custom_48eb00f8-cc04-4971-b250-4177e1a7af3b",
      "custom_0bae0ae6-a440-4569-8d6a-dd681a394f24"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
